import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Schedule from 'views/admin/schedule/components/Schedule'
import EventForm from './components/events/EventForm'
import SubEventForm from './components/sub-events/SubEventForm'
import EventSubEvents from './components/sub-events/EventSubEvents'
import TalkForm from '../academics/components/TalkForm'
import EventOrSubEventTalksOrPosters from './components/EventOrSubEventTalksOrPosters'
import NotFound from 'components/NotFound'

const ScheduleModule = () => {
  const { path } = useRouteMatch()
  const { conference } = useSelector((state) => state.conference)

  // Component that conditionally renders based on enableAcademics
  const AcademicProtectedRoute = ({ children }) => {
    return conference?.enableAcademics ? children : <NotFound />
  }

  return (
    <Switch>
      <Route exact path={path}>
        <Schedule />
      </Route>
      <Route path={`${path}/events/new`}>
        <EventForm />
      </Route>
      <Route path={`${path}/events/edit/:eventId`}>
        <EventForm />
      </Route>
      <Route path={`${path}/events/:eventId/sub-events/edit/:sessionId`}>
        <SubEventForm />
      </Route>
      <Route path={`${path}/events/:eventId/sub-events/new`}>
        <SubEventForm />
      </Route>
      <Route path={`${path}/sub-events/edit/:sessionId`}>
        <SubEventForm />
      </Route>
      <Route path={`${path}/sub-events/new`}>
        <SubEventForm />
      </Route>
      {/* Talk routes for events */}
      <Route path={`${path}/events/:eventId/talks/new`}>
        <AcademicProtectedRoute>
          <TalkForm />
        </AcademicProtectedRoute>
      </Route>
      <Route path={`${path}/events/:eventId/talks/edit/:talkId`}>
        <AcademicProtectedRoute>
          <TalkForm />
        </AcademicProtectedRoute>
      </Route>
      <Route path={`${path}/events/:eventId/sub-events/:sessionId/talks/new`}>
        <AcademicProtectedRoute>
          <TalkForm />
        </AcademicProtectedRoute>
      </Route>
      <Route path={`${path}/events/:eventId/sub-events/:sessionId/talks/edit/:talkId`}>
        <AcademicProtectedRoute>
          <TalkForm />
        </AcademicProtectedRoute>
      </Route>
      <Route path={`${path}/events/:eventId/talks`}>
        <AcademicProtectedRoute>
          <EventOrSubEventTalksOrPosters />
        </AcademicProtectedRoute>
      </Route>
      <Route path={`${path}/events/:eventId/sub-events/:sessionId/talks`}>
        <AcademicProtectedRoute>
          <EventOrSubEventTalksOrPosters />
        </AcademicProtectedRoute>
      </Route>

      <Route path={`${path}/events/:eventId/sub-events`}>
        <EventSubEvents />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  )
}

export default ScheduleModule
